import { Status } from 'shared/ui'
import { type SurveysStatus } from 'entities/Surveys/api/types'
import { statuses } from './config'

export interface ISurveyStatusProps {
  status: SurveysStatus
  className?: string
  ariaLabel?: string
}

export const SurveyStatus = ({ status, className, ariaLabel }: ISurveyStatusProps) => (
  <Status {...statuses[status]} className={className} ariaLabel={ariaLabel} />
)
